module.exports = __webpack_public_path__ + "media/w1.03ad31ea.mp3";